import React, { Component } from 'react';
import IShopTile from '../../Abstraction/IShopTile';
import { shopTiles } from '../../Storage/shopTiles';
import Styles from './styles.module.css';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class Shop extends Component{
    constructor(props:any){
        super(props);

        this.renderTiles = this.renderTiles.bind(this);
    }

    render(){
        return (
            <Container fluid className={Styles.container}>
                <Row noGutters>
                    <Col xs="12"><h2 className={Styles.shopTitle}>Shop</h2></Col>
                </Row>
                <Row noGutters className={Styles.tiles}>
                    {this.renderTiles()}
                </Row>
            </Container>
        )
    }

    renderTiles(){
        const tiles:any[] = [];

        shopTiles.forEach((tile:IShopTile) => {
            tiles.push(
            <Col xs="4">
                <Link to={`/shop/${tile.id}`}>
                    <img src={tile.image} className={Styles.tileImg}/>
                </Link>
            </Col>);
        });

        return tiles;
    }
}